export const BREADCRUMBS_RELOAD_INTERVAL = 500 // ms
